export const currentYear = new Date().getFullYear();
export const teamleadImage = require('static/images/avatars/team-lead-happy.png');
export const clientImage = require('static/images/avatars/claudia-sorger.png');
export const jokerImage = require('static/images/avatars/joker.png');
